import { Const } from '../lib/const.cls'

export const getters = {
    [Const.GET_PROFILE_INFO]: (state) => { return state.profileInfo },
    [Const.GET_PAYMENT_METHODS]: (state) => { return state.GetPaymentMethods },
    [Const.GET_TRADING_ACCOUNT]: (state) => { return state.tradingAccount },


    [Const.GET_NEWS_DATA]: (state) => { return state.newsData },
    [Const.GET_ECONOMIC_CALENDER_DATA]: (state) => { return state.economicCalData },
    [Const.GET_OPEN_TRADE]: (state) => { return state.openTradeList },
    [Const.GET_PENDING_ORDER]: (state) => { return state.pendingOrderList },
    [Const.GET_TRADE_HISTORY]: (state) => { return state.tradeHistoryList },
    [Const.GET_CALL_TRADE_HISTORY_API]: (state) => { return state.callTradeHistoryApi },
    [Const.GET_TRANSACTION_HISTORY]: (state) => { return state.transactionHistory },
    [Const.GET_ACCOUNT_BALANCE]: (state) => { return state.accBalance },
    [Const.GET_REJECTED_TRADE]: (state) => { return state.rejectedTradeList },
    [Const.GET_PENDING_TRADE]: (state) => { return state.pendingTradeList },
    [Const.GET_WS_ORDER]: (state) => { return state.wsOrder },
    [Const.GET_CURRENCY_PAIRS]: (state) => { return state.currencyPairs },
    [Const.GET_PRICE_SHIFT]: (state) => { return state.priceShift },
    [Const.GET_WATCH_LIST]: (state) => { return state.watchList },
    [Const.GET_ORDER_BOOK]: (state) => { return state.orderBook },
    [Const.GET_PROVIDER_LIST]: (state) => { return state.providerList },
    [Const.GET_USER_ACCOUNTS]: (state) => { return state.accountList },
    [Const.GET_USER_PROFILE]: (state) => { return state.profileData },
    [Const.GET_WS_STATUS]: (state) => { return state.wsStatus },
    [Const.GET_USER_SETTINGS]: (state) => { return state.userSettings },
    [Const.GET_ACTIVE_PRICE_ALERT]: (state) => { return state.activePriceAlert },
    [Const.GET_TRIGGERED_PRICE_ALERT]: (state) => { return state.triggeredPriceAlert },
    [Const.GET_PRICE_ALERT_NOTIFICATON]: (state) => { return state.priceAlertNotification },
    [Const.GET_PORTFOLIO]: (state) => { return state.portfolioData },
    [Const.GET_RAW_OBJECT]: (state) => { return state.rawObject },
    [Const.GET_DEFAULT_WORKSPACE_LIST]: (state) => { return state.defaultWorkSpaceList },
    [Const.GET_APP_THEME]: (state) => { return state.appTheme },
    [Const.GET_APP_CHART]: (state) => { return state.chartCompany; },
    [Const.GET_TECHNICAL_ANALYSIS]: (state) => { return state.technicalAnalysis },
    [Const.GET_PIVOT_DATA]: (state) => { return state.pivotData },
    [Const.GET_LEADERS_LIST]: (state) => { return state.leadersList },
    [Const.GET_ALL_LEADERS_LIST]: (state) => { return state.allLeadersList },
    [Const.GET_LEADER_DETAIL]: (state) => { return state.leaderDetail },
    [Const.GET_PROFIT_CHART_DATA]: (state) => { return state.profitChartData },
	[Const.GET_PERFORMANCE_CHART_DATA]: (state) => { return state.performanceChartData },
	[Const.GET_PORTFOLIO_CHART_DATA]: (state) => { return state.portfolioChartData },
	[Const.GET_DRAWDOWN_CHART_DATA]: (state) => { return state.drawdownChartData },
	[Const.GET_LEADER_TRADE_HISTORY]: (state) => { return state.leaderTradeHistory },
    [Const.GET_LEADER_FILTES]: (state) => { return state.leadersFilter },
    [Const.GET_FOLLOWERS_SETTING]: (state) => { return state.followersSetting },
    [Const.GET_USER_EQUITY_CHART_WITH_LEADER]: (state) => { return state.userEquityChartWithLeader },
    [Const.GET_USER_COPYTRADING_TOKEN]: (state) => { return state.userCopytradingDetails },
}


// WEBPACK FOOTER //
// ./src/plugins/commonAll/provider/store-addons/getters.js